import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './tenants-panel.css';
import { Redirect, Route } from 'react-router-dom';
import TenantManagement from './tenant-management/TenantManagement';
import RoutingService from '../../services/RoutingService';
const RS = new RoutingService();
class TenantsPanel extends ComponentHelper {
	render() {
		return (
			<div className="tenants-panel-view animated fadeIn">
				<Route exact path="/tenant-management/:tenant" render={() => <Redirect to={`/tenant-management/${RS.getCurrentTenant()}/environments`} />} />
				<Route path="/tenant-management/:tenant/:section" component={TenantManagement} />
			</div>
		);
	}
}

export default TenantsPanel;



// WEBPACK FOOTER //
// ./src/views/tenants-panel/TenantsPanel.js